import React, { useState } from 'react';
import { WarningBannerActionButton } from '../button';
import {
  Box,
  Typography,
  CircularProgress,
  Chip
} from '@mui/material';
import { ExitToApp, Person, Warning } from '@mui/icons-material';
import axios from 'axios';
import PageSnackbars from '../common/PageSnackbars';

const ImpersonationBanner = ({ currentUser, onUserChange }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleStopImpersonation = async () => {
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/stop-impersonation', {}, {
        withCredentials: true
      });

      setSuccess('Returned to original account');
      onUserChange(response.data.user);
    } catch (err) {
      console.error('Error stopping impersonation:', err);
      setError(err.response?.data?.error || 'Failed to return to original account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: 'warning.main',
          color: 'warning.contrastText',
          py: 1,
          px: 2,
          zIndex: 1400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: 1,
          height: 48
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Warning sx={{ mr: 1 }} />
          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
            You are currently viewing as:
          </Typography>
          <Chip
            icon={<Person />}
            label={currentUser?.firstName && currentUser?.lastName
              ? `${currentUser.firstName} ${currentUser.lastName} (${currentUser.login})`
              : currentUser?.login || 'Unknown User'}
            size="small"
            sx={{
              mx: 1,
              bgcolor: 'warning.dark',
              color: 'warning.contrastText',
              '& .MuiChip-icon': {
                color: 'warning.contrastText'
              }
            }}
          />
        </Box>

        <WarningBannerActionButton
          onClick={handleStopImpersonation}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : <ExitToApp />}
        >
          {loading ? 'Returning...' : 'Return to My Account'}
        </WarningBannerActionButton>
      </Box>

      <PageSnackbars
        successMessage={success}
        errorMessage={error}
        onCloseSuccess={() => setSuccess('')}
        onCloseError={() => setError('')}
        successAutoHideDuration={3000}
      />
    </>
  );
};

export default ImpersonationBanner;
